import { removeSpecialCharacters } from './util';

const prepositions = ['de', 'da', 'e', 'para'];

const isPreposition = (word) => !word || prepositions.includes(word);
export const parseKeywords = (text) => {
  const keywords = text.split(' ').map((word) => removeSpecialCharacters(word).toLowerCase());

  if (keywords.length === 1) {
    return keywords;
  }

  return keywords.filter((word) => !isPreposition(word));
};
